import {
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
} from "@mui/material";
import { errorMessage } from "components/AlertComponent";
import { useMaterialUIController } from "context";
import { getFilesWithNationalCode } from "controllers/FileController";
import { getFilesForuser } from "controllers/FileController";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import AdapterJalali from "@date-io/date-fns-jalali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { setFileVisible } from "controllers/FileController";
import { StoreFile } from "controllers/FileController";
import { insertPersonalPageAnswer } from "controllers/PageController";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import getText from "Translator";
import { getPatientDetails } from "controllers/FileController";
import LoadingOverlay from "react-loading-overlay";
import { getDate } from "date-fns";

let patientFromServer;
let menu;
export default function NewPatientComponent(props) {
  const [nationalCode, setNationalCode] = useState("");
  const [mode, setMode] = useState(0);
  const [nationalCodeList, setNationalCodeList] = useState([]);
  const [patientName, setPatientName] = useState("");
  const [patientFamily, setPatientFamily] = useState("");
  const [birthYear, setBirthYear] = useState();
  const [reload, setReload] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [patientExist, setPatientExist] = useState(true);
  const [focus, setFocus] = useState("nationalcode");
  const [controller, dispatch] = useMaterialUIController();
  const [patientDetails, setPatientDetails] = useState({});
  const navigate = useNavigate();

  const {
    file,
    from,
    closeHandle,
    selectedItem,
    createMenu,
    serachIconHandler,
    handleSearch,
    headline,
    capsule,
    title,
    getData,
  } = props;
  const getMenu = async () => {
    try {
      menu = await localStorage.getItem("$menu");
      if (menu) {
        menu = JSON.parse(menu);
      }
    } catch (err) {
      errorMessage(err, controller.lang);
    }
  };
  const createNewPatient = async () => {
    try {
      let savedFile;
      let file = "";
      if (file) {
        file = file;
      }
      let newFile = {
        file,
        headline: headline,
        capsule: capsule,
        patientName,
        patientFamily,
        title: title,
        showInForum: false,
        summary: "",
        showInForumAdmin: false,
        sendToServer: false,
        myquestion: "",
        sendToForumDate: new Date(),
        patientNationalCode: nationalCode,
        visible: true,
        birthDate: birthYear,
        gender: -1,
        fatherName: "",
        from: from,
        visitedpageslist: [],
        Account: controller.id,
      };
      setLoading(true);
      savedFile = await StoreFile(newFile, controller);

      setLoading(false);
      if (savedFile.success) {
        let datas = [
          {
            id: "5f87e27c7d51e72a84dc57d0", //1182
            answer: patientDetails.gender,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc5840", //1183
            answer: patientDetails.age,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc579d", //1267
            answer: patientDetails.weight,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc5772", //1268
            answer: patientDetails.height,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27b7d51e72a84dc55a3", //1761
            answer: patientDetails.phone,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
        ];
        setLoading(true);
        let newData = {
          file: savedFile.data._id,
          nationalCode,
          datas,
        };
        let savedAnswers = await insertPersonalPageAnswer(newData, controller);
        setLoading(true);

        console.log("sssssssss", savedAnswers);
        if (savedAnswers.success) {
          Swal.fire({
            text: getText("alertsuccess", controller.lang),
            position: "bottom-end",
            background: "#03fca1",
            showConfirmButton: false,
            timer: 1500,
          });
          let menuDB = await localStorage.getItem("$menu");
          if (menuDB) {
            menuDB = JSON.parse(menuDB);
            menuDB.file = savedFile.data._id;
            menuDB.nationalCode = nationalCode;
            menuDB.birthYear = birthYear;
            menuDB.showResultOfFile = false;
            menuDB.isMyFile = true;
            menuDB.limitedFile = false;
            menuDB.formType = 1;
            menuDB.from = "menu";
            menuDB.visitedpageslist = [];
            await localStorage.setItem("$menu", JSON.stringify(menuDB));
          }
        } else {
          Swal.fire({
            text: savedAnswers.message,
            position: "bottom-end",
            background: "#f1b3af",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      } else {
        Swal.fire({
          text: savedFile.message,
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (err) {
      setLoading(false);
      errorMessage(err, controller.lang);
    }
  };
  const startPage = async () => {
    try {
      if (nationalCode.trim() === "") {
        Swal.fire({
          text: "لطفا کد ملی را وارد نمایید",
        });
        return;
      } else {
        if (nationalCode !== "") {
          //
          if (
            nationalCode.length !== 10 ||
            patientName.length < 3 ||
            patientFamily.length < 3
          ) {
            Swal.fire({
              title: getText("warning", controller.lang),
              html: getText("validatenewpatient", controller.lang),
              confirmButtonText: getText("ok", controller.lang),
            });
            return;
          }
        }

        if (!patientExist) {
          await createNewPatient();
        } else {
          if (mode === 1 || mode === 4) {
            await createNewPatient();
          } else {
            closeHandle();
          }
        }
      }

      getData(20, 1, "");
      closeHandle();
    } catch (err) {
      setLoading(false);
      errorMessage(err, controller.lang);
    }
  };
  const getnationalCodes = async (search) => {
    try {
      if (search.length !== 10) {
        setBirthYear("");
        setPatientName("");
        setPatientFamily("");
        setPatientDetails({
          gender: "",
          age: "",
          weight: "",
          height: "",
          phone: "",
        });
        setPatientExist(true);
      }
      if (search.length > 4 && search.length < 10) {
        let filelist = [];
        let res = await getFilesWithNationalCode({ search }, controller);
        if (res.success) {
          setNationalCodeList(res.data);
        } else {
          Swal.fire({
            title: getText("warning", controller.lang),
            text:
              getText("probleminproccess", controller.lang) +
              "\n\n" +
              getText("checkintenetconnection", controller.lang),
            confirmButtonText: getText("ok", controller.lang),
          });
          setNationalCodeList([]);
        }
      } else {
        setNationalCodeList([]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorMessage(err, controller.lang);
    }
  };
  const processNationalCode = async (text) => {
    console.log(text);
    try {
      setLoading(true);
      if (!menu) {
        await getMenu();
      }
      let newData = {
        capsule: capsule,
        text,
        search: text,
      };
      console.log("asdasdaxxxxxx");

      let res = await getFilesForuser(newData, controller);

      if (res.success) {
        if (res.incapsule) {
          //props.setFileListx(text);
          handleSearch(text);
          serachIconHandler(true, text);
          setPatientFamily("");
          setPatientName("");
          setNationalCode("");
          setBirthYear("");
          setPatientDetails({
            gender: "",
            age: "",
            weight: "",
            height: "",
            phone: "",
          });

          setLoading(false);
          closeHandle();
          Swal.fire({
            text: getText("existedCode", controller.lang),
            showConfirmButton: false,
            position: "bottom-end",
            timerProgressBar: true,
            timer: 2000,

            // confirmButtonText: getText("ok", controller.lang),
          });
          return;
        }
      }
      setLoading(true);
      let pData = {
        text,
        nationalCode: text,
        capsule: capsule,
        birthYear,
      };
      patientFromServer = await getPatientDetails(pData, controller);

      console.log("asdasda", patientFromServer);
      if (!patientFromServer.success) {
        Swal.fire({
          title: getText("warning", controller.lang),
          text: getText("probleminproccess", controller.lang),
          confirmButtonText: getText("ok", controller.lang),
        });

        setLoading(false);
        return;
      }

      if (patientFromServer.success) {
        setMode(patientFromServer.data.fileMode);
        if (
          patientFromServer.data.fileMode === 0 ||
          patientFromServer.data.fileMode === 3
        ) {
          setPatientExist(false);

          setLoading(false);
          return;
        } else {
          if (patientFromServer.data.fileMode === 2) {
            if (from === "save") {
              closeHandle();
              Swal.fire({
                title: getText("warning", controller.lang),
                text: getText("existedCode", controller.lang),
                confirmButtonText: getText("ok", controller.lang),
              });
            } else {
              let newData = {
                file: patientFromServer.data._id,
                visible: true,
                isMyFile: true,
              };
              let visibleResult = await setFileVisible(
                newData,
                controller.token
              );
              if (visibleResult.success) {
                closeHandle();
                createMenu(
                  selectedItem,
                  controller.favorite,
                  patientFromServer.data.patientNationalCode
                );

                serachIconHandler(true, nationalCode);
              } else {
              }
            }

            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );
            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          } else if (patientFromServer.data.fileMode === 1 && from === "save") {
            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );

            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          } else {
            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );

            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          }
          setLoading(false);
        }
      }

      setLoading(false);
    } catch (err) {
      errorMessage(err, controller.lang);
    }
  };

  const convertToEnglishNumber = (str) => {
    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  };
  useEffect(() => {
    getMenu();
  }, []);
  return (
    <div
      style={{ padding: 10 }}
      className={controller.lang === "en" ? "ltr" : "rtl"}
    >
      <LoadingOverlay
        active={controller.loading}
        styles={{
          position: "fixed",
          top: -100,
          left: -100,
          bottom: -100,
          right: -100,
        }}
        spinner
        text={getText("loading", controller.lang)}
      >
        <Grid container style={{ marginTop: 15 }}>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              paddingRight: controller.lang === "en" ? 15 : 0,
              paddingLeft: controller.lang === "fa" ? 15 : 0,
            }}
          >
            {/* <b> {getText('nationalcode', controller.lang)}</b> */}
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label={getText("nationalcode", controller.lang) + "  *"}
              key="nationalcode"
              id="nationalcode"
              value={nationalCode}
              inputRef={(input) => {
                if (input != null && focus === "nationalcode") {
                  input.focus();
                }
              }}
              style={{
                backgroundColor:
                  nationalCode.length !== 10 ? "#ff9385" : "transparent",
              }}
              onFocus={() => {
                setFocus("nationalcode");
              }}
              fullWidth={true}
              variant="outlined"
              type="tel"
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                if (text.length > 10) {
                  text = text.substring(0, 10);
                }
                if (controller.id.length < 10) {
                  Swal.fire({
                    title: getText("warning", controller.lang),
                    text: getText("firstregister", controller.lang),
                    confirmButtonText: getText("ok", controller.lang),
                  });

                  return;
                }
                setNationalCode(text.trim());
                if (text.length > 3 && text.length < 10) {
                  getnationalCodes(text);
                }
                if (text.length === 10) {
                  setNationalCodeList([]);
                  processNationalCode(text);
                  // setFocus("birthyear");
                } else {
                  setPatientExist(true);
                }
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            <LocalizationProvider dateAdapter={AdapterJalali}>
              <DateTimePicker
                fullWidth
                label={getText("birthdate", controller.lang) + "  *"}
                key="birthyear"
                id="birthyear"
                views={["day", "month", "year"]}
                // views={["year"]}
                value={birthYear}
                onChange={(value) => {
                  let nowY = moment(new Date(), "yyyy").year();
                  let birthY = moment(value, "yyyy").year();

                  let temp = patientDetails;
                  temp.age = nowY - birthY;

                  setBirthYear(value);
                  setPatientDetails(temp);
                  setReload(new Date());
                  setFocus("name");
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth disabled />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid container style={{ marginTop: 15 }}>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              paddingRight: controller.lang === "en" ? 15 : 0,
              paddingLeft: controller.lang === "fa" ? 15 : 0,
            }}
          >
            {/* {patientExist+"asdasdas"} */}
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              style={{
                backgroundColor:
                  patientName.length < 3 && nationalCode.length == 10
                    ? "#ff9385"
                    : "transparent",
              }}
              label={getText("name", controller.lang) + "  *"}
              key="name"
              id="name"
              inputRef={(input) => {
                if (input != null && focus === "name") {
                  input.focus();
                }
              }}
              onFocus={() => {
                setFocus("name");
              }}
              fullWidth={true}
              variant="outlined"
              returnKeyType="next"
              disabled={patientExist}
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                setPatientName(text);
              }}
              value={patientName}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label={getText("family", controller.lang) + "  *"}
              key="family"
              id="family"
              inputRef={(input) => {
                if (input != null && focus === "family") {
                  input.focus();
                }
              }}
              onFocus={() => {
                setFocus("family");
              }}
              style={{
                backgroundColor:
                  patientFamily.length < 3 && nationalCode.length == 10
                    ? "#ff9385"
                    : "transparent",
              }}
              fullWidth={true}
              variant="outlined"
              disabled={patientExist}
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                setPatientFamily(text);
              }}
              value={patientFamily}
            />
          </Grid>
        </Grid>
        <div style={{ display: "none" }}>
          <Grid container style={{ marginTop: 15 }}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                paddingRight: controller.lang === "en" ? 15 : 0,
                paddingLeft: controller.lang === "fa" ? 15 : 0,
              }}
            >
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                style={{
                  backgroundColor:
                    patientDetails.age + "" == "" && nationalCode.length == 10
                      ? "#ff9385"
                      : "transparent",
                }}
                label={getText("age", controller.lang) + " *"}
                key="age"
                id="age"
                inputRef={(input) => {
                  if (input != null && focus === "age") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("age");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={true}
                maxLength={10}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.age = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.age}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("gender", controller.lang) + " *"}
                key="gender"
                id="gender"
                inputRef={(input) => {
                  if (input != null && focus === "gender") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("gender");
                }}
                style={{
                  backgroundColor:
                    patientDetails.gender + "" == "" &&
                    nationalCode.length == 10
                      ? "#ff9385"
                      : "transparent",
                }}
                fullWidth={true}
                variant="outlined"
                select
                disabled={patientExist}
                maxLength={10}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.gender = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.gender + ""}
              >
                <MenuItem key="0" value="61f8d077379abf268c7c1849">
                  {getText("female", controller.lang)}
                </MenuItem>
                <MenuItem key="1" value="61f8d077379abf268c7c184a">
                  {getText("male", controller.lang)}
                </MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 15 }}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                paddingRight: controller.lang === "en" ? 15 : 0,
                paddingLeft: controller.lang === "fa" ? 15 : 0,
              }}
            >
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("height", controller.lang)}
                key="height"
                id="height"
                inputRef={(input) => {
                  if (input != null && focus === "height") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("height");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.height = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.height}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("weight", controller.lang)}
                key="weight"
                id="weight"
                inputRef={(input) => {
                  if (input != null && focus === "weight") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("weight");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.weight = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.weight}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 15 }}>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("phone", controller.lang)}
                key="phone"
                id="phone"
                inputRef={(input) => {
                  if (input != null && focus === "phone") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("phone");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.phone = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.phone}
              />
            </Grid>
          </Grid>
        </div>
        <Grid
          container
          style={{ marginTop: 15, flex: 1, flexDirection: "row" }}
        >
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                setBirthYear("");
                setNationalCode("");
                setPatientName("");
                setPatientFamily("");
                setPatientDetails({
                  gender: "",
                  age: "",
                  weight: "",
                  height: "",
                  phone: "",
                });
                setPatientExist(true);

                closeHandle();
              }}
            >
              {getText("cancel", controller.lang)}
            </Button>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          ></Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                if (controller.id.length < 10) {
                  Swal.fire({
                    title: getText("warning", controller.lang),
                    text: getText("firstregister", controller.lang),
                    confirmButtonText: getText("ok", controller.lang),
                  });

                  return;
                }
                startPage();
              }}
            >
              {getText("continue", controller.lang)}
            </Button>
          </Grid>
        </Grid>
        {/* <Drawer
          anchor="right"
          variant="permanent"
          style={{ maxHeight: 300 }}
          PaperProps={{
            style: {
              position: "absolute",
            },
          }}
          open={true}
          onClose={() => setNationalCodeList([])}
        >
          <List autoFocus={false}>
            {nationalCodeList &&
              nationalCodeList.map((item, index) => (
                <ListItem
                  key={item.id}
                  button
                  onClick={() => {
                    setNationalCode(item.patientNationalCode);
                    processNationalCode(item.patientNationalCode);
                    setFocus("birthyear");
                    setNationalCodeList([]);
                    closeHandle();
                  }}
                >
                  <ListItemText primary={item.patientNationalCode} />
                </ListItem>
              ))}
          </List>
        </Drawer> */}
      </LoadingOverlay>
    </div>
  );
}
